module.exports = __webpack_public_path__ + "img/palce-img.1adec3f1.png";